import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import "assets/scss/website/app.scss";
import "react-rangeslider/lib/index.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const TablePayment = ({
	totalOffPayments,
	activeYear,
	downPayment,
	exchangeRate,
	frequency,
	activeYearNumber,
}) => {
	const { t } = useTranslation();
	const [year, setYear] = useState(null);
	const [downPaymentData, setDownPaymentData] = useState();
	const [offPayment, setOffPayment] = useState([]);
	const currency = useSelector((state) => state.Auth?.currency);

	useEffect(() => {
		setYear(activeYear?.years);
	}, [activeYear]);

	useEffect(() => {
		setDownPaymentData(downPayment);
	}, [downPayment]);

	useEffect(() => {
		let data = [];
		Object.keys(activeYear?.years).forEach((month, index) => {
			if (activeYear?.years[month].hasOwnProperty("off_payment")) {
				let result = Object.values(
					activeYear?.years[month].off_payment.reduce(
						(acc, { payment_name, payment_fees }) => {
							acc[payment_name] = acc[payment_name] || {
								payment_name,
								payment_fees: 0,
								index: index,
							};
							acc[payment_name].payment_fees += payment_fees;
							return acc;
						},
						{}
					)
				);
				result?.map((res) => data.push(res));
			}
		});
		const transformedArray = transformArray(data);

		setOffPayment(transformedArray);
	}, [activeYearNumber, activeYear]);

	function transformArray(array) {
		const transformedArray = array.reduce((result, item) => {
			if (!result[item.payment_name]) {
				result[item.payment_name] = { payment_name: item.payment_name };
			}

			const propertyName = `payment_fees${item.index}`;
			result[item.payment_name][propertyName] = item.payment_fees;
			return result;
		}, {});

		return Object.values(transformedArray);
	}

	return (
		<div className="table-responsive">
			<Table>
				<thead>
					<tr>
						<th className="text-color">{t("payment number")}</th>
						{activeYearNumber - 1 === 0 ? (
							<th className="text-color">{t("Down Payment")}</th>
						) : null}
						{frequency?.value == "monthly" && (
							<th className="text-color">{t("Monthly")}</th>
						)}
						{frequency?.value == "quarterly" && (
							<th className="text-color">{t("Quarterly")}</th>
						)}
						{frequency?.value == "semi" && (
							<th className="text-color">{t("Semi Annually")}</th>
						)}
						{frequency?.value == "annually" && (
							<th className="text-color">{t("Annually")}</th>
						)}

						{offPayment?.map((off, index) => {
							return (
								<th key={index}>
									{off.payment_name}
									<span
										className="text-color ms-3"
										style={{
											background: "#dedede80",
											padding: "4px",
											borderRadius: "7px",
											fontWeight: "500",
										}}>
										{totalOffPayments[off.payment_name]}%
									</span>
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{year
						? Object.keys(year).map((month, index) => {
								return (
									<tr key={index}>
										<td className="ps-3 text-color">{index + 1}</td>
										{activeYearNumber - 1 === 0 ? (
											<td className="text-color">
												{index === 0
													? `${
															exchangeRate?.symbol === "*"
																? toCurrency(
																		downPaymentData?.down_payment_amount *
																			exchangeRate?.exchange_rate
																  )
																: toCurrency(
																		downPaymentData?.down_payment_amount /
																			exchangeRate?.exchange_rate
																  )
													  } ${currency?.currency_code}  `
													: null}
												{index === 0 ? (
													<span
														className="ms-3 text-white"
														style={{
															background: "var(--primary-color)",
															padding: "4px",
															borderRadius: "7px",
															fontWeight: "500",
														}}>
														{downPaymentData?.down_payment}%{" "}
													</span>
												) : null}
											</td>
										) : null}
										{frequency?.value == "monthly" && (
											<td className="text-color">
												{exchangeRate?.symbol === "*"
													? toCurrency(
															year[month]?.monthly * exchangeRate?.exchange_rate
													  )
													: toCurrency(
															year[month]?.monthly / exchangeRate?.exchange_rate
													  )}{" "}
												{currency?.currency_code}
											</td>
										)}
										{frequency?.value == "quarterly" && (
											<td className="text-color">
												{year[month]?.quarterly
													? `${
															exchangeRate?.symbol === "*"
																? toCurrency(
																		year[month]?.quarterly *
																			exchangeRate?.exchange_rate
																  )
																: toCurrency(
																		year[month]?.quarterly /
																			exchangeRate?.exchange_rate
																  )
													  } ${currency?.currency_code}`
													: "-"}
											</td>
										)}
										{frequency?.value == "semi" && (
											<td className="text-color">
												{year[month]?.semi
													? `${
															exchangeRate?.symbol === "*"
																? toCurrency(
																		year[month]?.semi *
																			exchangeRate?.exchange_rate
																  )
																: toCurrency(
																		year[month]?.semi /
																			exchangeRate?.exchange_rate
																  )
													  } ${currency?.currency_code}`
													: "-"}
											</td>
										)}
										{frequency?.value == "annually" && (
											<td className="text-color">
												{year[month]?.annual
													? `${
															exchangeRate?.symbol === "*"
																? toCurrency(
																		year[month]?.annual *
																			exchangeRate?.exchange_rate
																  )
																: toCurrency(
																		year[month]?.annual /
																			exchangeRate?.exchange_rate
																  )
													  } ${currency?.currency_code}`
													: "-"}
											</td>
										)}

										{offPayment?.map((item, itemIndex) => {
											if (item.hasOwnProperty(`payment_fees${index}`)) {
												return (
													<td key={itemIndex} className="text-color">
														<span>
															{exchangeRate?.symbol === "*"
																? toCurrency(
																		item[`payment_fees${index}`] *
																			exchangeRate?.exchange_rate
																  )
																: toCurrency(
																		item[`payment_fees${index}`] /
																			exchangeRate?.exchange_rate
																  )}{" "}
															{currency?.currency_code}
														</span>
													</td>
												);
											} else {
												return (
													<td className="text-color" key={itemIndex}>
														-
													</td>
												);
											}
										})}
									</tr>
								);
						  })
						: null}
				</tbody>
			</Table>
		</div>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number.toFixed(1));
};

export default TablePayment;
